import { LogArgument } from 'rollbar';

export const trackError = (message: Error, error?: unknown) => {
  if (typeof window.Rollbar !== 'undefined') {
    window.Rollbar.error(message, error as LogArgument);
  } else {
    console.error(message, { error });
  }
};
